// src/components/CustomerSummary/components/tableFormats.js
// ============================================================================
// BLOCK CS.UI.TBLFMT.0 — ResizableTextTable format presets
// ----------------------------------------------------------------------------
// Purpose:
// - Centralize per-table formatting so UI tweaks are made in ONE place.
// ============================================================================

export const TABLE_FORMATS = {
  // --------------------------------------------------------------------------
  // BLOCK CS.UI.TBLFMT.1 — Payer Mix (3 cols + group shading)
  // --------------------------------------------------------------------------
  payerMix: {
    headersByCols: { 3: ['Payer', 'Count', '%'] },
    alignByCols: { 3: ['left', 'right', 'right'] },
    defaultWidthsByCols: { 3: { col1: 55, col2: 20, col3: 25 } },
    useGroupShading: true,
  },

  // --------------------------------------------------------------------------
  // BLOCK CS.UI.TBLFMT.2 — Patient Stats (2 cols + group shading)
  // --------------------------------------------------------------------------
  patientStats: {
    headersByCols: { 2: ['Metric', 'Value'] },
    alignByCols: { 2: ['left', 'right'] },
    defaultWidthsByCols: { 2: { col1: 75, col2: 25 } },
    useGroupShading: true,
  },

  // --------------------------------------------------------------------------
  // BLOCK CS.UI.TBLFMT.3 — Top 3 Study Indications (2 cols, nested ranks)
  // --------------------------------------------------------------------------
  top3StudyIndications: {
    headersByCols: { 2: ['Study Type', 'Indication'] },
    alignByCols: { 2: ['left', 'left'] },
    defaultWidthsByCols: { 2: { col1: 40, col2: 60 } },
    enableNestedRows: true,
    nestedIndentPx: 18,
    useGroupShading: true,
  },

  // --------------------------------------------------------------------------
  // BLOCK CS.UI.TBLFMT.4 — Top 3 Ordering Providers (2 cols, nested ranks)
  // --------------------------------------------------------------------------
  top3OrderingProviders: {
    headersByCols: { 2: ['Provider', 'Rank'] },
    alignByCols: { 2: ['left', 'right'] },
    defaultWidthsByCols: { 2: { col1: 75, col2: 25 } },
    enableNestedRows: true,
    nestedIndentPx: 18,
    useGroupShading: true,
  },

  // --------------------------------------------------------------------------
  // BLOCK CS.UI.TBLFMT.5 — Turnaround Times (3 cols, nested rows + multiline)
  // --------------------------------------------------------------------------
  turnaroundTimes: {
    headersByCols: { 3: ['Metric', 'Study Type', 'Value'] },
    alignByCols: { 3: ['left', 'left', 'right'] },
    defaultWidthsByCols: { 3: { col1: 48, col2: 34, col3: 18 } },
    enableNestedRows: true,
    nestedIndentPx: 18,
    multilineCols: [2],
    useGroupShading: false,
  },

  // --------------------------------------------------------------------------
  // BLOCK CS.UI.TBLFMT.6 — Device Utilization (3 cols, nested rows + multiline)
  // --------------------------------------------------------------------------
  deviceUtilization: {
    headersByCols: { 3: ['Metric', 'Device Group', 'Value'] },
    alignByCols: { 3: ['left', 'left', 'right'] },
    defaultWidthsByCols: { 3: { col1: 52, col2: 32, col3: 16 } },
    enableNestedRows: true,
    nestedIndentPx: 18,
    multilineCols: [1],
    useGroupShading: false,
  },

  // --------------------------------------------------------------------------
  // BLOCK CS.UI.TBLFMT.7 — Average Rx Length (3 cols)
  // --------------------------------------------------------------------------
  averageRxLength: {
    headersByCols: { 3: ['Study Type', 'Unit', 'Value'] },
    alignByCols: { 3: ['left', 'left', 'right'] },
    defaultWidthsByCols: { 3: { col1: 50, col2: 20, col3: 30 } },
  },

  // --------------------------------------------------------------------------
  // BLOCK CS.UI.TBLFMT.8 — Support Tickets Resolved (2 cols)
  // --------------------------------------------------------------------------
  supportTicketsResolved: {
    headersByCols: { 2: ['Metric', 'Value'] },
    alignByCols: { 2: ['left', 'right'] },
    defaultWidthsByCols: { 2: { col1: 75, col2: 25 } },
    useGroupShading: true,
  },

  // --------------------------------------------------------------------------
  // BLOCK CS.UI.TBLFMT.9 — Urgent / Emergent Notifications (MDN) (2 cols)
  // --------------------------------------------------------------------------
  urgentEmergentNotifications: {
    headersByCols: { 2: ['Metric', 'Value'] },
    alignByCols: { 2: ['left', 'right'] },
    defaultWidthsByCols: { 2: { col1: 75, col2: 25 } },
    useGroupShading: true,
  },
};

export default TABLE_FORMATS;
